export const CollaboratorsService = Symbol.for('CollaboratorsService');
